import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import EmptyComponent from '../../../component/EmptyComponent';
import moment from 'moment/moment';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import { useDebouncedCallback } from 'use-debounce';
import {
  DeleteReels,
  GetAllReels,
  SearchForReelsByTitle,
} from '../../../redux/admin/reels/reels_services_sync';
import {
  updateReelsDetails,
  updateReelsId,
} from '../../../redux/admin/reels/reels_slices';

const Reels = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deletePayload, setDeletePayload] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [searchReels, setSearchReels] = useState('');

  const {
    completeReelsSearch,
    completeReels,
    reels_loader,
    reels_page,
    reels_limit,
    editReelsId,
  } = useSelector((state) => state.reels);

  useEffect(() => {
    dispatch(GetAllReels({ page: reels_page, limit: reels_limit }));

    return () => {};
  }, []);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (selectedItem) {
      dispatch(updateReelsId(selectedItem?._id));
      dispatch(
        DeleteReels({
          ...selectedItem,
          id: selectedItem?._id,
        })
      );
      setShowDeleteModal(false);
      setSelectedItem(null);
    }
  };

  const handlePageChange = (page) => {
    dispatch(
      GetAllReels({
        page: page,
        limit: reels_limit,
      })
    );
  };

  const debounced = useDebouncedCallback(
    async (value) => {
      if (value) {
        dispatch(
          SearchForReelsByTitle({
            name: value,
            page: 0,
            limit: reels_limit,
          })
        );
      }
    },
    // delay in ms
    1000
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchReels(value);

    if (value) {
      debounced(value);
    }
  };

  console.log(completeReels, 'completeReels');

  return (
    <>
      <div class="card max-w-[500px]">
        <div class="card-header">
          <form class="chat-search pb-0">
            <div class="chat-search-box">
              <input
                value={searchReels || ''}
                class="form-control"
                type="text"
                name="search"
                placeholder="Search ..."
                onChange={handleInputChange}
              />

              <button type="submit" class="btn btn-sm btn-link search-icon p-0">
                <i class="bx bx-search-alt"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center gap-1">
              <h4 class="card-title flex-grow-1">All Reels List</h4>

              <NavLink to="/admin_dashboard/create_reels">
                <a class="btn btn-sm btn-primary">Add Reels</a>
              </NavLink>
            </div>
            <div>
              {reels_loader ? (
                <TableLoader
                  headerArray={['Reels', 'link', 'Date', 'Action']}
                  itemArray={[1, 2, 3, 4]}
                />
              ) : (
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-hover table-centered">
                    <thead class="bg-light-subtle">
                      <tr>
                        <th style={{ width: '20px' }}>
                          <div class="form-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="customCheck1"
                            />
                            <label
                              class="form-check-label"
                              for="customCheck1"
                            ></label>
                          </div>
                        </th>
                        <th>Reels</th>
                        <th>Link</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchReels ? (
                        completeReelsSearch?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          completeReelsSearch?.docs?.map((item, key) => (
                            <>
                              {item?._id !== editReelsId ? (
                                <tr key={key}>
                                  <td>
                                    <div class="form-check">
                                      <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="customCheck2"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="customCheck2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                        <img
                                          src={item?.reel_image}
                                          alt=""
                                          class="avatar-md"
                                        />
                                      </div>
                                      <p class="text-dark fw-medium fs-15 mb-0">
                                        {item?.title}
                                      </p>
                                    </div>
                                  </td>
                                  <td>{item?.link}</td>
                                  <td>
                                    {moment(item?.date).format('dd MMM yyyy')}
                                  </td>
                                  <td>
                                    <div class="d-flex gap-2">
                                      <a
                                        onClick={() => {
                                          dispatch(updateReelsDetails(item));
                                          navigate(
                                            '/admin_dashboard/edit_reels'
                                          );
                                        }}
                                        class="btn btn-soft-primary btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:pen-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>

                                      <a
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleDeleteClick(item);
                                        }}
                                        className="btn btn-soft-danger btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:trash-bin-minimalistic-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <SingleTableLoader itemArray={[1, 2, 3, 4]} />
                              )}
                            </>
                          ))
                        )
                      ) : completeReels?.docs?.length <= 0 ? (
                        <EmptyComponent />
                      ) : (
                        completeReels?.docs?.map((item, key) => (
                          <>
                            {item?._id !== editReelsId ? (
                              <tr key={key}>
                                <td>
                                  <div class="form-check">
                                    <input
                                      type="checkbox"
                                      class="form-check-input"
                                      id="customCheck2"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="customCheck2"
                                    ></label>
                                  </div>
                                </td>
                                <td>
                                  <div class="d-flex align-items-center gap-2">
                                    <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                      <img
                                        src={item?.reel_image}
                                        alt=""
                                        class="avatar-md"
                                      />
                                    </div>
                                    <p class="text-dark fw-medium fs-15 mb-0">
                                      {item?.title}
                                    </p>
                                  </div>
                                </td>
                                <td>{item?.link}</td>
                                <td>
                                  {moment(item?.date).format('dd MMM yyyy')}
                                </td>
                                <td>
                                  <div class="d-flex gap-2">
                                    <a
                                      onClick={() => {
                                        dispatch(updateReelsDetails(item));
                                        navigate('/admin_dashboard/edit_reels');
                                      }}
                                      class="btn btn-soft-primary btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:pen-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>

                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDeleteClick(item);
                                      }}
                                      className="btn btn-soft-danger btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:trash-bin-minimalistic-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <SingleTableLoader itemArray={[1, 2, 3, 4]} />
                            )}
                          </>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div class="card-footer border-top">
              <nav aria-label="Page navigation example">
                <PaginationComponent
                  currentPage={completeReels?.page}
                  totalItems={completeReels?.totalDocs}
                  pageSize={reels_limit}
                  handlePageChange={handlePageChange}
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <div
          className="modal-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            className="modal-container"
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '400px',
            }}
          >
            <div className="modal-header">
              <h5>Delete Reels</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowDeleteModal(false)}
              />
            </div>
            <div className="modal-body" style={{ padding: '20px 0' }}>
              <p>
                Are you sure you want to delete{' '}
                <strong>{selectedItem?.name}</strong>?
              </p>
            </div>
            <div
              className="modal-footer"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className="btn btn-light"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleConfirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Reels;
